import { JobInfoFragment } from "domains/Task/graphql/fragments";
import gql from "graphql-tag";
import { SubTaskInfoFragment } from "./fragments";

export const JobsClientById = gql`
  query jobsByStatusAndClientId($clientID: ID!, $status: [JobStatus]) {
    jobsByStatusAndClientId(clientID: $clientID, status: $status) {
      ...JobInfo
    }
  }
  ${JobInfoFragment}
`;

export const SubTaskByStatusAndClientID = gql`
  query allSubTasksByClient($params: SubTasksByClientFetchParams!, $queries: SubTasksFetchQueries) {
    allSubTasksByClient(params: $params, queries: $queries) {
      data {
        ...SubTaskInfo
      }
      totalPages
      countTotal
    }
  }

  ${SubTaskInfoFragment}
`;

export const JobByClientFromSubtask = gql`
  query jobByClientFromSubtask($input: JobByClientFromSubtaskParams!) {
    jobByClientFromSubtask(params: $input) {
      code
      error
      message
      data {
        ...JobInfo
      }
    }
  }

  ${JobInfoFragment}
`;
